export { default as DesktopGameCard } from './DesktopGameCard'
export { default as MobileGameCard } from './MobileGameCard'
export { default as PlayNowBtn } from './PlayNowBtn'
export { default as PlayForFunBtn } from './PlayForFunBtn'
